<template>
    <div class="mainDiv">
        <div class="left-portion">
            <div class="headingTextDiv">
                <p class="headingTextTop">Bridging the gap between brands & <br> Indian farmers</p>
                <p class="headingTextBottom">
                   Connect directly with the vast audience of 10 million+ farmers across crops, geographies and varied interests on Krishify!

                </p>
            </div>
            <div class="ctaButtons">
                <div class="CreateAcountbtn" @click="createAccount()">
                    <p class="CreateAcountbtntext">Create account</p>
                </div>
                <div class="requestDemobtn" @click="handleclickReachus()">
                    <p class="requestDemobtntext">Request a demo</p>
                </div>
            </div>
        </div>
        <div class="right-portion">
            <img  class="introcardimage" height="100%"  width="100%" src="../../../assets/LandingPage/IntroCard.png" />
          
        </div>
    </div>
</template>

<script>
import MoengageEventGenerator from "../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../helpers/moengageEvents";
import MoengageAtrributes from "../../../helpers/moengageAttributes";
export default {
    name: "introcard",
    data() {
        return {
            isMobile: false,
            
        };
    },
    props:{
      onclickreachus:{
        type:Function,
        required:true,
      }
    },

    methods: {
       
        handleclickReachus(){
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Request for demo",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Reach Us Section",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

            this.onclickreachus();
        },

        createAccount() {
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Create Account",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Log In Page",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

            sessionStorage.setItem('buttonType','register');
            if (this.isMobile) {
                this.$router.push({ name: "login" });
            } else {
                this.$router.push({ name: "login" });
            }
        },
        //function to check mobile device
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
        gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
    },
    mounted() {
        this.checkDevices();
    },
};
</script>

<style lang="scss" scoped>
.mainDiv {
    display: flex;
    background-color: #ffffff;
    justify-content: space-between;
    margin: 0px auto;
    gap: 5px;
    text-align: center;
    align-items: center;
}
.left-portion {
    width: 40%;
}
.right-portion {
    width: 55%;
}
.headingTextTop {
    margin-bottom: 14px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 48px;
    line-height: 56px;
    color: #3a3f3a;
    text-align: start;
}
.headingTextBottom {
    height: 100px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 26px;
    color: #797e79;
    text-align: start;
}
.ctaButtons {
    display: flex;
    background: #ffffff;
    justify-content: space-between;
 
}
.CreateAcountbtn {
    display: flex;
    gap: 10px;
    height: 47px;
    background: #339137;
    border-radius: 3px;
    width: 45%;
    cursor: pointer;
    box-shadow: 3px 3px 11px rgba(28, 50, 27, 0.33);
}
.CreateAcountbtntext {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0px;
    color: #ffffff;
}
.requestDemobtn {
    display: flex;
    height: 47px;
    background: #fbf9d4;
    border-radius: 3px;
    width: 45%;
    cursor: pointer;
 

}
.requestDemobtntext {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 0px;
    line-height: 19px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3a3f3a;
}
.headingTextDiv {
}
@media all and (max-width: 940px) {
    .requestDemobtntext {
        font-size: 15px;
    }
}
@media all and (max-width: 940px) {
    .CreateAcountbtntext {
        font-size: 15px;
    }
}
@media all and (max-width: 1024px) {
    .headingTextBottom {
        font-size: 18px;
    }
}
@media all and (max-width: 1024px) {
    .right-portion {
        width:100%;
    }
}
@media all and (max-width: 1024px) {
    .headingTextTop {
        font-size: 30px;
        line-height: 140%;
    }
}
@media all and (max-width: 1024px) {
    .mainDiv {
        display: flex;
        flex-direction: column-reverse;
    }
}
@media all and (max-width: 1024px) {
    .left-portion {
        width: 100%;
    }
}
@media all and (max-width: 335px) {
    .ctaButtons {
        margin-top: 30px;
    }
}


</style>
